export enum UserStatus {
  Invited = 'INVITED',
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
  Removed = 'REMOVED',
  ScheduledInvite = 'SCHEDULED INVITE',
  ScheduledRemoval = 'SCHEDULED REMOVAL'
}
